import { FormEvent, useEffect } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import { v4 } from 'uuid'

import Card from '@/components/Card/Card'
import Container from '@/components/Container/Container'
import Panel from '@/components/Panel/Panel'
import Spinner from '@/components/Spinner/Spinner'
import Typeahead from '@/components/Typeahead/Typeahead'
import { scrollToTop } from '@/utils/helpers'

import styles from './RecsForm.module.scss'

type Props = {
  commander: string
  commander2: string
  decklist: string
  errors: string[]
  excludeLands: boolean
  isLoading: boolean
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  setCommander: (s: string) => void
  setCommander2: (s: string) => void
  setDecklist: (s: string) => void
  setExcludeLands: (e: any) => void
}

const RecsForm = ({
  commander,
  commander2,
  decklist,
  errors,
  excludeLands,
  isLoading,
  onSubmit,
  setCommander,
  setCommander2,
  setDecklist,
  setExcludeLands,
}: Props) => {
  useEffect(() => {
    scrollToTop()
  }, [])

  console.log(excludeLands)

  return (
    <Container>
      <Panel>
        <Form className='d-grid gap-3 pb-3' onSubmit={onSubmit}>
          <div className={styles.topRow}>
            <Form.Group as={Col} className={styles.commanderGroup}>
              <Form.Label>Commander</Form.Label>
              <Typeahead
                clearButton
                onChange={async (e: any) => setCommander(e[0])}
                placeholder='Enter Commander'
                type='commanders'
                value={commander}
              />
              {commander && (
                <div className='mt-3'>
                  <Card name={commander} />
                </div>
              )}
            </Form.Group>
            <Form.Group as={Col} className={styles.commanderGroup}>
              <Form.Label>Commander 2 (optional)</Form.Label>
              <Typeahead
                clearButton
                onChange={async (e: any) => setCommander2(e[0])}
                placeholder='Enter Commander 2 (Partner)'
              />
              {commander2 && (
                <div className='mt-3'>
                  <Card name={commander2} />
                </div>
              )}
            </Form.Group>
          </div>
          <Form.Group>
            <Form.Label>Decklist</Form.Label>
            <Form.Control
              as='textarea'
              onChange={(e) => setDecklist(e.target.value)}
              placeholder='Accepts several formats, e.g. ...                                                                                                                                                                                                                                                                                                                                                                    ...                                                                                                                                                                                                                                                                                                                                                                                                                                                                      Sol Ring                                                                                                                                                                                                                                                                                                                                                                                                                                                        1 Sun Titan                                                                                                                                                                                                                                                                                                                                                                                                                                          1x Vandalblast'
              rows={10}
              value={decklist}
            />
          </Form.Group>
          <Form.Group>
            <Form.Check
              checked={excludeLands}
              id='excludeLandsCheckbox'
              label='Exclude Lands'
              onChange={() => setExcludeLands(!excludeLands)}
              type='checkbox'
            />
          </Form.Group>
          {errors.map((error) => (
            <Alert className='mb-3' key={v4()} variant='danger'>
              {error}
            </Alert>
          ))}
          <Form.Group>
            <div className='d-flex gap-2 justify-content-end'>
              <Button
                disabled={
                  isLoading ||
                  (commander.length === 0 && commander2.length === 0 && decklist.length === 0 && !excludeLands)
                }
                onClick={() => {
                  setCommander('')
                  setCommander2('')
                  setDecklist('')
                  setExcludeLands(false)
                }}
                variant='danger'
              >
                Reset
              </Button>
              <Button disabled={isLoading} type='submit' variant='primary'>
                {isLoading ? <Spinner /> : 'Submit'}
              </Button>
            </div>
          </Form.Group>
        </Form>
      </Panel>
    </Container>
  )
}

export default RecsForm
